import { gql } from '@/__generated__/gql'

export const ContentReferenceCreateManyMutation = gql(`
  mutation ContentReferenceCreateMany(
  $contentReferences: [ContentReferenceCreateInput!]!,
  $deleteOmittedReferences: Boolean = false
  ) {
    contentReferenceCreateMany(contentReferences: $contentReferences, deleteOmittedReferences: $deleteOmittedReferences) {
      contentReferences {
        id
        sortKey
      }
    }
  }
`)
